import React, { useState } from 'react';

import { acceptCase } from '../../services/notification';
import { ToastService } from '../../services/toast.service';
import RejectionModal, { type CancelConfirmationLabels, type RejectionLabels } from './RejectionModal/RejectionModal';
import { useResolutionConfig } from './ResolutionConfigContext';

export type { CancelConfirmationLabels,RejectionLabels }

const DEFAULT_ERROR_TEXT = 'Error during the saving process.'
const DEFAULT_ERROR_SUBTEXT = 'Check your internet connection. If the problem continues feel free to contact us.'
const DEFAULT_SUCCESS_TEXT = 'Changes are saved successfully!'

interface CaseResolutionButtonsProps {
    acceptDisabled?: boolean;
    rejectDisabled?: boolean;
    caseId?: string | null;
    caseNumber?: string | null;
    caseSubject?: string | null;
    onAccept?: () => void;
}

const CaseResolutionButtons: React.FC<CaseResolutionButtonsProps> = ({
    acceptDisabled,
    rejectDisabled,
    caseId,
    caseNumber,
    caseSubject,
    onAccept,
}) => {
    const resolutionConfig = useResolutionConfig();
    const [showModal, setShowModal] = useState(false);
    const [accepting, setAccepting] = useState(false);

    const errorText    = resolutionConfig?.errorText    ?? DEFAULT_ERROR_TEXT
    const errorSubtext = resolutionConfig?.errorSubtext ?? DEFAULT_ERROR_SUBTEXT
    const successText  = resolutionConfig?.successText  ?? DEFAULT_SUCCESS_TEXT

    const handleAccept = async () => {
        setAccepting(true);
        const success = await acceptCase(caseId ?? '');
        setAccepting(false);
        if (success) {
            ToastService.success(successText);
            onAccept?.();
        } else {
            ToastService.error(errorSubtext, errorText);
        }
    };

    const handleRejectSubmit = () => {
        setShowModal(false);
    };

    return (
        <>
            <div className="cop-notification__accept-reject">
                <button
                    className="cop-notification__btn cop-notification__btn--accept"
                    disabled={acceptDisabled || accepting}
                    onClick={handleAccept}
                >
                    {accepting && (
                        <span className="cop-notification__mark-all-spinner" aria-hidden="true" />
                    )}
                    Accept
                </button>
                <button
                    className="cop-notification__btn cop-notification__btn--reject"
                    disabled={rejectDisabled}
                    onClick={() => setShowModal(true)}
                >
                    Reject
                </button>
            </div>

            {showModal && (
                <RejectionModal
                    caseId={caseId}
                    caseNumber={caseNumber}
                    caseSubject={caseSubject}
                    rejectionLabels={resolutionConfig?.rejectionLabels}
                    cancelConfirmationLabels={resolutionConfig?.cancelConfirmationLabels}
                    errorText={errorText}
                    errorSubtext={errorSubtext}
                    successText={successText}
                    onClose={() => setShowModal(false)}
                    onSubmit={handleRejectSubmit}
                />
            )}
        </>
    );
};

export default CaseResolutionButtons;

